<template>
  <LegalPage
    title="Impressum"
    subtitle="Informationen gemäß § 5 DDG (Digitale-Dienste-Gesetz)"
  >
    <template v-slot:sections>
      <!-- Angaben zum Betreiber -->
      <section class="imprint-section">
        <div class="section-header">
          <span class="section-icon-bg"><BIcon icon="building" /></span>
          <h2>Angaben zum Betreiber</h2>
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Fitnessstudio</span>
            <span class="info-value">DailyFit</span>
          </div>
          <div class="info-item">
            <span class="info-label">Inhaber</span>
            <span class="info-value">Thomas Albang</span>
          </div>
          <div class="info-item">
            <span class="info-label">Anschrift</span>
            <span class="info-value">Am Bahnhof 2a<br>92526 Oberviechtach<br>Deutschland</span>
          </div>
          <div class="info-item">
            <span class="info-label">Telefon</span>
            <span class="info-value">
              <a href="tel:+491718203954" class="contact-link">0171 8203954</a>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">E-Mail</span>
            <span class="info-value">
              <a href="mailto:albang89@web.de" class="contact-link">albang89@web.de</a>
            </span>
          </div>
        </div>
      </section>

      <!-- Urheberrecht -->
      <section class="imprint-section">
        <div class="section-header">
          <span class="section-icon-bg"><BIcon icon="shield-check" /></span>
          <h2>Urheberrecht</h2>
        </div>
        <p class="section-text">
          Die Inhalte und Werke, die von den Seitenbetreibern auf dieser Website erstellt wurden,
          unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.
          Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
          der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors oder Erstellers.
        </p>
      </section>

      <!-- Streitschlichtung -->
      <section class="imprint-section">
        <div class="section-header">
          <span class="section-icon-bg"><BIcon icon="exclamation-triangle" /></span>
          <h2>Streitschlichtung</h2>
        </div>
        <p class="section-text">
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      </template>
  </LegalPage>
</template>

<script>
import LegalPage from '@/Layouts/LegalPageLayout.vue';

export default {
  name: 'ImprintPage',
  components: {
    LegalPage
  }
}
</script>

<style scoped>
/* === Sections === */
.imprint-section {
  margin-bottom: 0;
  padding: 2rem 0;
  border-bottom: 1px solid #f0f0f0;
  animation: sectionFade 0.5s ease both;
}

.imprint-section:first-child {
  padding-top: 0;
}

.imprint-section:nth-child(1) { animation-delay: 0.08s; }
.imprint-section:nth-child(2) { animation-delay: 0.16s; }
.imprint-section:nth-child(3) { animation-delay: 0.24s; }

@keyframes sectionFade {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.imprint-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

/* === Section Header === */
.section-header {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  margin-bottom: 1.5rem;
}

.section-icon-bg {
  font-size: 1rem;
  color: #28a745;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(40, 167, 69, 0.08), rgba(40, 167, 69, 0.15));
  border-radius: 10px;
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.3px;
}

/* === Section Text === */
.section-text {
  color: #4b5563;
  line-height: 1.75;
  margin: 0;
  font-size: 0.9375rem;
}

/* === Info Grid === */
.info-grid {
  display: grid;
  gap: 0;
}

.info-item {
  display: flex;
  align-items: baseline;
  gap: 1.5rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  transition: background 0.2s ease;
}

.info-item:hover {
  background: #f9fafb;
}

.info-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #9ca3af;
  min-width: 110px;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.info-value {
  font-size: 0.9375rem;
  color: #1a1a1a;
  line-height: 1.6;
  font-weight: 500;
}

.contact-link {
  color: #1a1a1a;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  transition: color 0.2s ease;
}

.contact-link::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 0;
  height: 1.5px;
  background: #28a745;
  border-radius: 1px;
  transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.contact-link:hover {
  color: #28a745;
}

.contact-link:hover::after {
  width: 100%;
}

/* === Developer Card === */
.developer-card {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.developer-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #28a745, #20c997);
  border-radius: 0 2px 2px 0;
}

.developer-card:hover {
  border-color: rgba(40, 167, 69, 0.25);
  box-shadow: 0 4px 16px rgba(40, 167, 69, 0.06);
}

.developer-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.developer-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.2px;
}

.developer-role {
  font-size: 0.8125rem;
  color: #9ca3af;
  font-weight: 500;
}

.developer-contact {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.dev-contact-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #6b7280;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.25s ease;
  letter-spacing: 0.1px;
}

.dev-contact-link:hover {
  color: #28a745;
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.04);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.1);
}

/* === Responsive === */
@media (max-width: 767.98px) {
  .developer-card {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 575.98px) {
  .imprint-section {
    padding: 1.5rem 0;
  }

  .info-item {
    flex-direction: column;
    gap: 0.125rem;
    padding: 0.625rem 0.75rem;
  }

  .info-label {
    min-width: unset;
    font-size: 0.75rem;
  }

  .developer-card {
    padding: 1.25rem;
  }

  .developer-contact {
    width: 100%;
  }

  .dev-contact-link {
    width: 100%;
    justify-content: center;
  }
}
</style>